import defaultSettings from '../setting';

const title = defaultSettings.title;

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}`;
  }
  return `${title}`;
}
